import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectStickerPackById, setEditId } from "../../../store/sticker_maker/stickerPacksSlice";
import {
  blockStickerPack,
  destroyStickerPack,
  fetchStickerPack, publishStickerPack,
  unBlockStickerPack, unPublishStickerPack
} from "../../../actions/sticker_maker/stickerPacksActions";
import stickerMakerUrls from "../../../configs/sticker_maker/stickerMakerUrls";

import {
  LikeOutlined,
  HeartOutlined,
  SwitcherOutlined, CheckCircleOutlined, StopOutlined, EyeInvisibleOutlined, EyeOutlined
} from "@ant-design/icons";
import { message } from "antd";
import Tabs from "../../../componets/Tabs";
import PageLayout from "../_partials/PageLayout";
import IconText from "../../../componets/IconText";
import StatsIcons from "../../../componets/StatsIcons";
import Edit from "./Edit";
import SummaryShow from "../../../componets/SummaryShow";
import SidebarShow from "./_partials/_SidebarShow";
import Stickers from "./_partials/_Stickers";
import Details from "./_partials/_Details";
import {Button, ButtonDestroy, ButtonEdit} from "../../../componets/Buttons";
import { ActiveTag, PublishedTag, StatusTag } from "./_partials/_Tags";
import { fetchCategories } from "../../../actions/sticker_maker/categoriesActions";

const Show: React.FC = () => {
  const { id }      = useParams();
  const navigate    = useNavigate();
  const dispatch    = useAppDispatch();
  const stickerPack = useAppSelector(state => id ? selectStickerPackById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchCategories({ target: 1 }));
      dispatch(fetchStickerPack(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    dispatch(setEditId(id));
  }

  function onClickDestroy() {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyStickerPack(id));

    if (destroyStickerPack.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      const url = stickerPack?.target === 0 ? stickerMakerUrls.contentPath() : stickerMakerUrls.communityPath();
      setTimeout(() => navigate(url), 1000);
    }

    if (destroyStickerPack.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  function onClickUnBlock(id: number) {
    dispatch(unBlockStickerPack(id));
  }

  function onClickBlock(id: number) {
    dispatch(blockStickerPack(id));
  }

  function unPublish(id: number) {
    dispatch(unPublishStickerPack(id));
  }

  function publish(id: number) {
    dispatch(publishStickerPack(id));
  }

  const statusTags = () => {
    if (!stickerPack) {
      return null;
    }

    return (
      <div className='v-mt-15'>
        <StatusTag key='tag-status' status={stickerPack.status} />
        <PublishedTag key='tag-published' published={stickerPack.published} />
        <ActiveTag key='tag-active' active={stickerPack.active} />
      </div>
    )
  }

  const ToggleBlockButton = () => {
    if (!stickerPack) {
      return null;
    }

    if (stickerPack.status === 2) {
      return (
        <Button title='UnBlock' onClick={() => onClickUnBlock(stickerPack.id)} icon={CheckCircleOutlined} />
      )
    } else {
      return (
        <Button title='Block' onClick={() => onClickBlock(stickerPack.id)} icon={StopOutlined} />
      )
    }
  }

  const TogglePublishButton = () => {
    if (!stickerPack) {
      return null;
    }

    if (stickerPack.published) {
      return <Button title='UnPublish' onClick={() => unPublish(stickerPack.id)} icon={EyeInvisibleOutlined} />
    } else {
      return <Button title='Publish' onClick={() => publish(stickerPack.id)} icon={EyeOutlined} />
    }
  }

  return (
    <PageLayout className='v-stickerPacks-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            stickerPack &&
              <SummaryShow
                title={stickerPack.name}
                subtitle={statusTags()}
                image={stickerPack.image_url}
                createdAt={stickerPack.created_at}
                updatedAt={stickerPack.updated_at}
                className='v-mb-15'
                actions={[
                  <TogglePublishButton key='button-publish' />,
                  <ToggleBlockButton key='button-block' />,
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />,
                  <ButtonDestroy key='button-destroy' onClick={onClickDestroy} />,
                ]}
              />
          }

          <StatsIcons
            icons={[
              <IconText tooltip='popular' icon={HeartOutlined} text={stickerPack?.popular_count} />,
              <IconText tooltip='likes' icon={LikeOutlined} text={stickerPack?.likes_count} />,
              <IconText tooltip='stickers' icon={SwitcherOutlined} text={stickerPack?.stickers_count} />,
              <IconText tooltip='approved stickers' icon={SwitcherOutlined} text={stickerPack?.active_stickers_count} />
            ]}
          />
        </div>

        <Tabs
          paramsKey='tab'
          defaultActiveKey='stickers'
          items={[
            { label: 'Details', key: 'details', children: <Details stickerPack={stickerPack} /> },
            { label: 'Stickers', key: 'stickers', children: <Stickers stickerPackId={id} /> }
          ]}
        />
      </div>

      <SidebarShow id={id} />

      <Edit />
    </PageLayout>
  )
}

export default Show;
